export const TransformProductMode = {
  Map: "map",
  Generate: "generate",
} as const;

export type TransformProductMode =
  (typeof TransformProductMode)[keyof typeof TransformProductMode];

export const TRANSFORM_PRODUCT_MODES = [
  TransformProductMode.Map,
  TransformProductMode.Generate,
] as const;

export const TRANSFORM_PRODUCT_MODE_LABELS: Record<
  TransformProductMode,
  string
> = {
  [TransformProductMode.Map]: "Use product mapping",
  [TransformProductMode.Generate]: "Generate new product",
};

export const TRANSFORM_PRODUCT_MAPPED_PATH_LABEL = "Product maps";
export const TRANSFORM_PRODUCT_UNMAPPED_PATH_LABEL = "Product doesn't map";

const DEFAULT_TRANSFORM_PRODUCT_MODE = TransformProductMode.Map;

export function transformProductModeOrDefault(
  mode: TransformProductMode | undefined,
): TransformProductMode {
  return mode ?? DEFAULT_TRANSFORM_PRODUCT_MODE;
}

export function isTransformProductMapMode(
  mode: TransformProductMode | undefined,
): boolean {
  return transformProductModeOrDefault(mode) === TransformProductMode.Map;
}

export function visibleTransformProductModes({
  hasRecommerceSourceConnection,
  currentMode,
}: {
  hasRecommerceSourceConnection: boolean;
  currentMode?: TransformProductMode;
}): readonly TransformProductMode[] {
  if (
    hasRecommerceSourceConnection ||
    currentMode === TransformProductMode.Generate
  ) {
    return TRANSFORM_PRODUCT_MODES;
  }
  return [TransformProductMode.Map];
}

export function shouldOfferTransformProductStep({
  isGrading,
}: {
  isGrading: boolean;
}): boolean {
  return isGrading;
}
